var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTimerGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "timer_grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB-ADMIN-(Web)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facturation-\\u2022-Liste-des-prestations",
    transform: "translate(-1289.000000, -463.000000)",
    fill: "#848F9D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1291.78,466.978 C1292.85,466.127 1294.17,465.664 1295.53,465.665994 C1296.95,465.665994 1298.25,466.157 1299.28,466.978 L1300.24,466.009 L1301.19,466.952 L1300.22,467.921 C1300.92,468.803 1301.36,469.867 1301.49,470.99 C1301.62,472.113 1301.43,473.248 1300.94,474.267 C1300.45,475.285 1299.68,476.144 1298.72,476.745 C1297.77,477.346 1296.66,477.665 1295.53,477.665 C1294.4,477.665 1293.29,477.346 1292.34,476.745 C1291.38,476.144 1290.61,475.285 1290.12,474.267 C1289.63,473.248 1289.44,472.113 1289.57,470.99 C1289.7,469.867 1290.14,468.803 1290.84,467.921 L1289.87,466.953 L1290.82,466.01 L1291.78,466.979 L1291.78,466.978 Z M1295.53,476.333 C1296.14,476.333 1296.75,476.212 1297.32,475.977 C1297.88,475.743 1298.4,475.399 1298.83,474.966 C1299.26,474.533 1299.61,474.018 1299.84,473.452 C1300.08,472.886 1300.2,472.279 1300.2,471.666 C1300.2,471.053 1300.08,470.446 1299.84,469.88 C1299.61,469.314 1299.26,468.8 1298.83,468.366 C1298.4,467.933 1297.88,467.589 1297.32,467.355 C1296.75,467.12 1296.14,466.999 1295.53,466.999 C1294.29,466.999 1293.11,467.491 1292.23,468.366 C1291.36,469.241 1290.86,470.428 1290.86,471.666 C1290.86,472.904 1291.36,474.091 1292.23,474.966 C1293.11,475.841 1294.29,476.333 1295.53,476.333 Z M1296.2,470.999 L1298.2,470.999 L1294.86,475.333 L1294.86,472.333 L1292.86,472.333 L1296.2,467.996 L1296.2,470.999 Z M1292.86,463.666 L1298.2,463.666 L1298.2,464.999 L1292.86,464.999 L1292.86,463.666 Z",
    id: "timer_grey"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimerGrey);
export default __webpack_public_path__ + "static/media/icon_timer_grey.15a81bc38cb9c6ffbc609cea45b18f63.svg";
export { ForwardRef as ReactComponent };